// extracted by mini-css-extract-plugin
export default {"content":"ErrorMsg_content__5UYTV"};